import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";

import "./index.css";

import App from "./App";
import Customizer from "./routes/Customizer";
import Cart from "./routes/Cart";

const NoMatchRoute = () => {
  const production =
    process.env.NODE_ENV === "production" &&
    !process.env.REACT_APP_CALLBACK_URL.includes("staging");
  if (production) {
    window.location.assign(`https://${process.env.REACT_APP_SHOP_URL}`);
  } else {
    return (
      <div>
        The URL requires a product and variant ID. Try this one:{" "}
        <Link to="/6711493820439/39976820047895" style={{ color: "blue" }}>
          /6711493820439/39976820047895
        </Link>
        .
      </div>
    );
  }
};

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          <Route path="/cart" element={<Cart />} />
          <Route path="/:productID/:variantID" element={<Customizer />} />
        </Route>
        <Route path="*" element={<NoMatchRoute />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
